module.exports = __webpack_public_path__ + "static/media/S1-28-Phroniac-cod48.7d50522a.png";